import { Link, Typography, alpha } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { categoryActions } from 'entities/Category/model/slices/CategorySlice';
import { getUserCanManageCatalogItems } from 'entities/User/model/selectors/userPermissionsSeletors';
import { useMarketplaceNavigation } from 'features/SearchCatalogItems/lib/hooks/useMarketplaceNavigation';
import openBoxSearch from 'shared/assets/svg/open-box-search.svg';
import { useAppDispatch } from 'shared/lib/hooks/useAppDispatch';
import { EmptyPlaceholder } from 'shared/ui/EmptyPlaceholder/EmptyPlaceholder';

interface CustomListSearchEmptyProps {
    searchQuery: string;
}

export const CustomListSearchEmpty = ({
    searchQuery,
}: CustomListSearchEmptyProps) => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const canEditCatalog = useSelector(getUserCanManageCatalogItems);
    const { navigateToMarketplace } =
        useMarketplaceNavigation('property-catalog');

    const onSearchPropertyCatalog = () => {
        const query = searchQuery.trim();
        if (!query) {
            return;
        }

        dispatch(categoryActions.clearCategorySelection());

        navigateToMarketplace({
            searchValue: query,
            skipReset: false,
        });
    };

    return (
        <EmptyPlaceholder
            image={openBoxSearch}
            childrenContainerSx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
            }}
        >
            <Typography
                color={(theme) => alpha(theme.palette.common.black, 0.5)}
                variant="subtitle2"
                sx={{
                    maxWidth: '280px',
                    textAlign: 'center',
                    marginBottom: '16px',
                }}
            >
                {t('No items found')}.
            </Typography>
            {canEditCatalog && (
                <Link
                    data-testid="custom-list-search-catalog-link"
                    component="button"
                    variant="subtitle2"
                    sx={{
                        lineHeight: '2.4rem',
                        textAlign: 'center',
                        cursor: 'pointer',
                    }}
                    underline="hover"
                    onClick={onSearchPropertyCatalog}
                >
                    {t('Search the Property Catalog')}.
                </Link>
            )}
        </EmptyPlaceholder>
    );
};
